@if ((newsActionState$ | async).pending) {
  <rs-web-loading-skeleton
    [show]="true"
    [types]="[LoadingType.HEADER, LoadingType.MULTIPLECARD]"
  ></rs-web-loading-skeleton>
} @else {
  @if ((news$ | async).length > 0) {
    <hr />

    <div class="news-widget">
      <rs-web-cards-container-header
        (tapped)="onTapOverview()"
        [buttonText]="'general.overview_a'"
        [icon]="icon"
        [title]="title"
      ></rs-web-cards-container-header>
      <div class="news-widget__overflow">
        <div class="news-widget__content">
          @for (general of news$ | async; track general.node.id; let i = $index) {
            @if (newsLimit - 1 > i) {
              <rs-web-content-card
                (tapped)="onTap($event)"
                [date]="general.node.publishedAt"
                [id]="general.node.id"
                [image]="general.node | contentTitleImage | async"
                [hasImage]="general.node | hasTitleImage"
                [preset]="contentCardPreset.NEWS"
                [text]="general.node.text"
                [title]="general.node.title"
                [pinned]="general.node.pinned"
                class="news-widget__content-card"
              ></rs-web-content-card>
            } @else {
              @if (newsLimit - 1 === i) {
                <a [routerLink]="overviewLink" class="im:card news-widget__extra-card">
                  {{ buttonText | translate }}
                </a>
              }
            }
          }
        </div>
      </div>
    </div>
  }
}
